import React, { useState, useMemo } from "react";
import { Row, Col } from "react-bootstrap";
import Accordion from "../../../components/Accordion";
import AdminMissingRemittanceForm from "./AdminMissingRemittanceForm";
import SharedMainSelectableClientGrid from "shared/components/grids/clientGrid/SharedMainSelectableClientGrid";
import useGridDataStateResetProcessing from "shared/hooks/useGridDataStateResetProcessing";
import useGridButtons from "shared/components/grids/hooks/useGridButtons";
import { MoneyCell } from "../../../components/grid/Kendo/CustomKendoGridCells";
import { GetISODate } from "shared/helpers/DateHelpers";
import {
  DefaultColumnWidth,
  DefaultDateColumnWidth,
  DefaultBooleanOrShortWidthColumnWidth,
} from "../../../components/grid/Kendo/KendoGridAndColumnConstants";
import { GridColumn as Column } from "@progress/kendo-react-grid";

import AdminMissingRemittanceDetailsModal from "./AdminMissingRemittanceDetailsModal";

export default function AdminMissingRemittance(props) {
  const { passedProps } = props;
  const user = passedProps.user.email;
  const [showModal, setShowModal] = useState(false);
  const [missingRemittanceData, setMissingRemittanceData] = useState([]);
  const [submittedFormData, setSubmittedFormData] = useState(null);
  const pmidKey = "remittanceId";

  const _container = React.useRef();
  // Grid setup following FeeAndAdjustmentResearch pattern
  const gridApiGetEndpoint = "api/MissingRemittances/GetAdminMissingRemittance";

  // Transform form data to API parameters
  const apiParameters = useMemo(() => {
    if (!submittedFormData) return null;

    return {
      user: user,
      fromDate: submittedFormData.fromDate
        ? GetISODate(submittedFormData.fromDate)
        : "",
      toDate: submittedFormData.toDate
        ? GetISODate(submittedFormData.toDate)
        : "",
      checkNumber: submittedFormData.checkNumber,
      payerId:
        submittedFormData.selectedPayer === "" ||
        submittedFormData.selectedPayer === null
          ? null
          : submittedFormData.selectedPayer.value,
      mpid: submittedFormData.mpid,
      nCPDP:
        submittedFormData.selectedLocation === "" ||
        submittedFormData.selectedLocation === null
          ? null
          : submittedFormData.selectedLocation.value,
      parentCompanyId:
        submittedFormData.selectedParentCompany === "" ||
        submittedFormData.selectedParentCompany === null
          ? null
          : submittedFormData.selectedParentCompany.value,
    };
  }, [submittedFormData, user]);

  // Grid buttons setup
  const { gridButtons } = useGridButtons({
    refresh: true,
    export: true,
  });
  // Grid state reset processing
  const {
    gridDataStateResetProcessingInitiated,
    InitiateGridDataStateReset,
    GridDataStateResetCompleted: onGridDataStateResetCompleted,
  } = useGridDataStateResetProcessing();

  function handleFormSubmit(e) {
    InitiateGridDataStateReset();
    setSubmittedFormData(e);
  }

  function handleFormReset(e) {
    setSubmittedFormData(null);
    InitiateGridDataStateReset();
  }

  const StatusActionCell = (props) => {
    async function editUpdateClick() {
      let rowData = props.dataItem;
      setMissingRemittanceData(rowData);
      setShowModal(true);
    }

    return (
      <td className="noWrap" {...props.style}>
        <a
          onClick={editUpdateClick}
          style={{
            cursor: "pointer",
            textDecoration: "underline",
            color: "#015CAB",
          }}
        >
          Edit/Update
        </a>
      </td>
    );
  };
  return (
    <React.Fragment>
      <div className="feature" id="admin-missing-remittance">
        <Accordion defaultExpanded label="Search & Filter">
          <Row>
            <Col className="higher-zindex-filters">
              <AdminMissingRemittanceForm
                handleFormSubmit={handleFormSubmit}
                passedProps={passedProps}
                handleFormReset={handleFormReset}
              />
            </Col>
          </Row>
        </Accordion>
        <div ref={_container}>
          <Row>
            <Col className="tight-grid multi-line-filter">
              {" "}
              <SharedMainSelectableClientGrid
                apiGetEndpoint={gridApiGetEndpoint}
                apiParameters={apiParameters}
                dataItemKey={pmidKey}
                styleOverride={{ height: "600px" }}
                exportFileNamePrefix={"AdminMissingRemittances"}
                gridButtons={gridButtons}
                gridDataStateResetProcessingInitiated={
                  gridDataStateResetProcessingInitiated
                }
                onGridDataStateResetCompleted={onGridDataStateResetCompleted}
                passedProps={passedProps}
              >
                <Column
                  field=""
                  title="Action"
                  filterable={false}
                  sortable={false}
                  groupable={false}
                  cells={{ data: StatusActionCell }}
                  width={DefaultColumnWidth()}
                />
                <Column
                  field="payer"
                  title="Payer"
                  width={DefaultColumnWidth()}
                />
                <Column
                  field="mpid"
                  title="MPID"
                  width={DefaultColumnWidth()}
                />
                <Column
                  field="checkNumber"
                  title="Check Number"
                  width={DefaultColumnWidth()}
                />
                <Column
                  field="checkAmount"
                  title="Amount"
                  width={DefaultColumnWidth()}
                  filter="numeric"
                  cells={{ data: MoneyCell }}
                />
                <Column
                  field="checkDate"
                  title="Check Date"
                  width={DefaultDateColumnWidth()}
                  filter="date"
                  format="{0:d}"
                />
                <Column
                  field="reqDate"
                  title="Req Date"
                  width={DefaultDateColumnWidth()}
                  filter="date"
                  format="{0:d}"
                />
                <Column
                  field="fileSource"
                  title="File Source"
                  width={DefaultColumnWidth()}
                />
                <Column
                  field="ncpdp"
                  title="NCPDP"
                  width={DefaultColumnWidth()}
                />
                <Column
                  field="requestBy"
                  title="Requested By"
                  width={DefaultColumnWidth()}
                />

                <Column
                  field="centralPay"
                  title="Central Pay"
                  filter="boolean"
                  width={DefaultBooleanOrShortWidthColumnWidth()}
                />
              </SharedMainSelectableClientGrid>
            </Col>
          </Row>
        </div>

        <AdminMissingRemittanceDetailsModal
          showModal={showModal}
          setShowModal={setShowModal}
          parentComponentRef={_container}
          missingRemittanceRequest={missingRemittanceData}
        />
      </div>
    </React.Fragment>
  );
}
